









































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import ContentTemplateDeleteModal from "@/components/contentTemplates/modals/ContentTemplateDeleteModal.vue";
import ContentTemplateCopyModal from "@/components/contentTemplates/modals/ContentTemplateCopyModal.vue";
import SelectContentTemplateType from "@/components/contentTemplates/modals/SelectContentTemplateType.vue";
import ExportContentTemplatesModal from "@/components/contentTemplates/modals/ExportContentTemplatesModal.vue";
import FileAlertModal from "@/components/files/modals/FileAlertModal.vue";
import draggable from "vuedraggable";
import ContentTemplateDeleteNotAllowedModal from "@/components/contentTemplates/modals/ContentTemplateDeleteNotAllowedModal.vue";

// service methods
import { getContentTemplatesByType, swapOrder, importTemplates, checkDelete } from "@/services/contentTemplates/contentTemplateService";
// types
import { ContentTemplate, TemplateSimple } from "@/services/contentTemplates/types";
import { contentTemplatesFields } from "@/components/contentTemplates/fields/contentTemplatesFields";
import { Option } from "@/services/common/types";
import { CurrentUser } from "@/store/authentication/types";

// css
import "vue-select/dist/vue-select.css";
import i18n from "@/i18n";
const namespace: string = "authentication";

@Component({
    components: {
        vSelect,
        "content-template-delete-modal": ContentTemplateDeleteModal,
        "content-template-copy-modal": ContentTemplateCopyModal,
        "select-content-template-type": SelectContentTemplateType,
        "export-content-templates-modal": ExportContentTemplatesModal,
        "file-alert-modal": FileAlertModal,
        "content-template-delete-not-allowed-modal": ContentTemplateDeleteNotAllowedModal,
        draggable
    }
})
export default class ContentTemplates extends Vue {
    @Prop({ default: "fixedHtml" }) private templateType!: string;
    @Getter("getCurrentUser", { namespace }) currentUser!: CurrentUser;

    // local state
    contentTemplates = [] as Array<ContentTemplate>;
    fields = contentTemplatesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;
    type = "fixedHtml"
    exportMode = false;

    // filter
    filterWidth = "" as string;
    filterHeight = "" as string;
    tagOptions = [] as Array<Option>;
    selectedTag = null as Option | any;

    // filter options
    searchText = "" as string;

    // lifecycle hooks
    public created(): void {
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    public mounted(): void {
        this.selectType(this.templateType);
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    openSelectTypeModal() {
        (this.$refs.selectContentTemplateTypeModal as any).open();
    }

    deleteContentTemplate(id: string, name: string) {
        checkDelete(id).then(response => {
            if (response.length > 0) {
                (this.$refs.contentTemplateDeleteNotAllowedModal as any).open(response);
                return;
            }
            (this.$refs.contentTemplateDeleteModal as any).open(id, name);
        });
    }

    copyContentTemplate(id: string, name: string) {
        (this.$refs.contentTemplateCopyModal as any).open(id, name);
    }

    navigateToContentTemplateForm(id: string) {
        if (this.type === "html") {
            return {
                name: "updateHtmlTemplate",
                params: { contentTemplateId: id }
            };
        } if (this.type === "fixedHtml") {
            return {
                name: "updateFixedHtmlTemplate",
                params: { contentTemplateId: id }
            };
        }
    }

    selectType(type: string) {
        this.type = type;
        this.exportMode = false;
        this.loadContentTemplates();
    }

    fetchData() {
        this.loadContentTemplates();
    }

    loadContentTemplates() {
        this.isBusy = true;
        this.contentTemplates = [] as Array<ContentTemplate>;
        getContentTemplatesByType(this.type).then(response => {
            this.contentTemplates = response;
            this.contentTemplates.forEach((el) => { Vue.set(el, "selected", false); });
            if (this.type === "fixedHtml") {
                this.initTags();
            }
        }).finally(() => {
            this.isBusy = false;
        });
    }

    initTags() {
        const allTags = this.contentTemplates.flatMap(x => x.tags);
        const uniqueTags = [...new Set(allTags.map(i => JSON.stringify(i)))].map(i => JSON.parse(i));
        const sortedTags = uniqueTags.sort(function (a, b) {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.tagOptions = sortedTags.map(x => ({ id: x.id, text: x.name } as Option));
    }

    clearFilter() {
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedTag = null;
        this.loadContentTemplates();
    }

    selectRow(item: ContentTemplate) {
        if (this.exportMode) {
            item.selected = !item.selected;
        }
    }

    toggleExportMode() {
        this.exportMode = !this.exportMode;
        this.contentTemplates.forEach((el) => { el.selected = false; });
    }

    exportContentTemplates() {
        const selectedTemplates = this.contentTemplates.filter(x => x.selected).map(x => ({
            id: x.id,
            name: x.name,
            height: x.height,
            width: x.width
        } as TemplateSimple)).sort(function (a, b) {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        if (selectedTemplates.length > 0) (this.$refs.exportContentTemplatesModal as any).open(selectedTemplates);
    }

    importContentTemplates() {
        (this.$refs.fileInput as any).click();
    }

    validateFile(file: File): boolean {
        const fileExtension = file.name.split(".").pop()!;
        if (fileExtension.toLowerCase() !== "vsctemplate") {
            (this.$refs.fileAlertModal as any).open(i18n.t("file.extensionNotAllowed"));
            return false;
        }
        return true;
    }

    async onFileUploadChange(event: any) {
        let file = event.target.files[0];
        if (!this.validateFile(file)) {
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        this.isBusy = true;
        importTemplates(formData).then(() => {
            file = {} as File;
            (this.$refs.fileInput as any).value = null;
            event.target.value = "";
            this.loadContentTemplates();
        });
    }

    // computed and watchers
    get model(): Array<ContentTemplate> {
        return this.contentTemplates.filter(
            x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase()) || x.tags.some(y => y.name.toLowerCase().includes(this.searchText.toLowerCase()))) &&
                (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                (this.filterHeight === "" ? true : x.height === +this.filterHeight) &&
                (this.selectedTag === null ? true : x.tags.some(y => y.id === this.selectedTag.id))
        );
    }

    set model(data: Array<ContentTemplate>) {
        this.contentTemplates = data;
    }

    get filterActive(): boolean {
        return (this.searchText !== "" || this.filterWidth !== "" || this.filterHeight !== "");
    }

    get numberOfSelectedTemplates(): number {
        return this.contentTemplates.filter(x => x.selected).length;
    }

    dragEnd(data: any) {
        if (data.newIndex === data.oldIndex) return; // If we didn't move, we don't need to do anything.
        const filteredData: ContentTemplate[] = JSON.parse(JSON.stringify(this.model));
        const idMap = filteredData.map(x => x.id);
        swapOrder(idMap);
    }
}
